import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    border: '5px solid transparent',
    borderRadius: 20,
    '&:hover': {
      border: '5px solid ' + theme.palette.primary.main,
      transform: 'scale(1.01)',
      cursor: 'pointer'
    }
  },
  noStyle: {
    width: '100%',
    height: '100%',
    '-webkit-box-shadow': 'none',
    '-moz-box-shadow': 'none',
    boxShadow: 'none'
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: 'white',
  },
  header: {
    height: 120,
  },
  imageContainer: {
    width: '15em',
    height: '15em'
  },
  image: {
    zIndex: 2,
    width: '100%',
    height: '100%',
    borderRadius: 20,
    // objectFit: 'cover'
    // border: '8px solid black'
  },
  bow: {
    marginTop:0,
    position: 'absolute',
    width: '9em',
    top: 40,
    left: 0,
    zIndex: 0,
  },
  delete: {
    '&:hover': {
      cursor:'pointer',
      textDecoration: 'underline'
    }
  },
  title: {
    fontFamily: "'Inter', sans-serif;",
    fontStyle: 'normal',
    fontWeight: 600,
    color:' #272730',
    fontSize:20,
  }
}));

export default function(props) {
  const classes = useStyles();
  const [showGif, setShowGif] = React.useState(false)
  let {name, pic, price, desc, gif} = props

  return (
    <Card className={props.noStyle ? classes.noStyle: classes.root}>
      <CardContent>
        <Grid container item xs={12} justify={'center'}>
          {props.delete &&
          <Typography align={'center'} color={'error'} onClick={props.deleteItem} className={classes.delete}>
            Remove
          </Typography>}
        <Grid item xs={12} container justify={'center'}>
          <div className={classes.imageContainer}>
            <img
              src={showGif && gif ? gif:pic}
              onMouseOver={() => setShowGif(true)}
              onMouseLeave={() => setShowGif(false)}
              className={classes.image}/>
          </div>
        </Grid>
          <Grid item xs={12} className={!props.noStyle ? classes.header:''} container alignContent={'center'} justify={'center'}>
            <Typography className={classes.title} align={'center'}>{name}</Typography>
          </Grid>
          {!props.noStyle && <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary" component="p" style={{fontSize:20}}>
              ${price}
            </Typography>
          </Grid>}
        </Grid>
      </CardContent>
    </Card>
  );
}
